/** Normalize PostgREST / Auth / plain Error objects into a readable string. */
export function formatSupabaseError(err, fallback = 'Request failed') {
  if (err == null) return fallback;
  if (typeof err === 'string') return err || fallback;
  if (err instanceof Error && err.message) return err.message;
  if (typeof err.message === 'string' && err.message) return err.message;
  if (typeof err.error_description === 'string' && err.error_description) {
    return err.error_description;
  }
  if (typeof err.error === 'string' && err.error) return err.error;
  try {
    return JSON.stringify(err);
  } catch {
    return fallback;
  }
}
